import React, { useContext } from 'react'
import { AssetTotals } from './AssetTotals'
import { AssetsContext } from '../../context'
import { AssetTabs } from './AssetTabs'

export const Index = () => {
  const { state } = useContext(AssetsContext)
  const { assets } = state

  return (
    <>
      <DisconnectedAssetsMessage
        hasDisconnectedAssets={assets.some(asset => (asset.flagged_for_deletion))}
      />
      <AssetTotals />
      <AssetTabs />
    </>
  )
}

const DisconnectedAssetsMessage = ({ hasDisconnectedAssets }) =>
  hasDisconnectedAssets
    ? <p className='assets__disconnected-message'>We have detected that some of your assets have become disconnected from the automated import. These assets will not be included in the calculations</p>
    : null
